import { Stack } from "@mui/material";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import { formatDateTimeShort } from "@entrilia/shared/utilities/dateUtils";
import type { ReportAccessState, WorkbookRun } from "../../../../../api/types/workbookRuns.types";
import WorkbookReportItem from "../../common/workbook-report/WorkbookReportItem";
import WorkbookReportItemSheetName from "../../common/workbook-report/WorkbookReportItemSheetName";

interface Props {
  workbookRun: WorkbookRun;
}

const WorkbookRunReportsList = ({ workbookRun }: Props) => {
  return (
    <ScrollableFlexContainer>
      <Stack spacing={1}>
        {workbookRun.reportsSettings.map((report) => {
          const reportAccessState: ReportAccessState = {
            reportCode: report.reportCode,
            hasAccessToReport: report.hasAccessToReport ?? true,
            isReportDeleted: report.isReportDeleted ?? false,
            isConfigurationValid: true,
            isProcessing: report.isProcessing ?? false,
          };
          return (
            <WorkbookReportItem
              key={report.id}
              clientCode={report.clientCode}
              isLocked={report.isLocked ?? false}
              reportAccessState={reportAccessState}
              reportName={report.caption}
              status={report.status}
              lastChangedAt={report.changedAt ? formatDateTimeShort(new Date(report.changedAt)) : ""}
              workbookFilters={workbookRun.workbookFilters}
              reportFilters={report.filters}
              reportKind={report.reportKind}
              reportSource={report.reportSource}
              reportId={report.id}
              reportType={report.reportType}
              SheetName={<WorkbookReportItemSheetName report={report} />}
              errorMessage={report.errorMessage}
              textColorForUpdating={"text.disabled"}
            />
          );
        })}
      </Stack>
    </ScrollableFlexContainer>
  );
};

export default WorkbookRunReportsList;
